import Admins from '../components/templates/admins';

export const AdminsContainer = () => {
  return <Admins />;
};
